import { ConfigurationRequestKeys } from "@services/configuration";
import { services } from "@src/dependencies";
import { useApiRequest } from "@utils/http-client";

export const useUpdateConfigurations = (
  appId,
  organizationId,
  options = {},
) => {
  const { configurationService } = services;

  const { loading, success, sendRequest, error, resetStatus } = useApiRequest(
    async (configurations) => {
      // Build the request data
      const configSettings = Object.entries(configurations)
        .map(([key, value]) => {
          if (key !== "whitelistedUrls") {
            return { ...value, value: String(value.value) };
          }
          return null;
        })
        .filter(Boolean);

      const data = {
        [ConfigurationRequestKeys.CONFIG_SETTINGS]: configSettings,
      };

      if (configurations.whitelistedUrls) {
        data[ConfigurationRequestKeys.WHITELISTED_URLS] =
          configurations.whitelistedUrls;
      }

      await configurationService.updateOrganizationConfiguration(
        appId,
        organizationId,
        data,
      );
      options.onSuccess?.();
    },
    false,
  );

  return {
    loading,
    success,
    error,
    resetStatus,
    updateConfiguration: sendRequest,
  };
};
